import React from 'react'
import Dashboard from '../../components/admin/dashboard/Dashboard'

function DashboardPage() {
  return (
    <div>
        <Dashboard/>
    </div>
  )
}

export default DashboardPage